import { connect } from 'react-redux';
import TenantBasedHome from '../../../components/providers/TenantBasedHome';
import { profile } from 'core/selectors';

export default connect(
  state => ({
    profile: profile(state),
  }),
  {},
)(TenantBasedHome); 